import { render } from "./BreadCrumbs.vue?vue&type=template&id=6d3970fd"
import script from "./BreadCrumbs.vue?vue&type=script&lang=js"
export * from "./BreadCrumbs.vue?vue&type=script&lang=js"

import "./breadCrumbs.scss?vue&type=style&index=0&lang=scss"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__